var render = function render(_c,_vm){return (_vm.props.mandatory || _vm.$scopedSlots.default)?_c('dl',{staticClass:"dl1",class:[_vm.data.class, _vm.data.staticClass]},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }